import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { RequestTypes } from '../../../models/enums/request-types.enum';
import { HttpService } from './../http.service';

import { HttpConfiguration } from '../../../app.http.config';

@Injectable()
export class DealerHttpService extends HttpService {
    constructor(httpConfig: HttpConfiguration, http: HttpClient) {
        super('api/dealer/', RequestTypes.InternalApi, httpConfig, http);
    }

    public requestToBecome(dto: any): Observable<any> {
        return this.post('requestToBecome', dto).pipe();
    }

    public requestToBecomeSpecialOffer(dto: any): Observable<any> {
        return this.post('business-offer', dto).pipe();
    }

    public getClientSubscriptions(): Observable<any> {
        return this.get('getClientSubscriptions', null).pipe();
    }

    public getAvailableAccessCards(): Observable<any> {
        return this.get('getAvailableAccessCards', null).pipe();
    }

    public getAccessCards(): Observable<any> {
        return this.get('getAccessCards', null).pipe();
    }

    public activateAcesscardForClient(clientId: string, accesscardId: string) {
        return this.post(`activateAccesscardForClient/${clientId}/${accesscardId}`, null).pipe();
    }

    public dealerActivationNewCard(item: any): Observable<any> {
        return this.post('dealerActivationNewCard', item).pipe();
    }

    public changeNewPassword(clientId: string, password: string): Observable<any> {
        return this.post(`changeNewPassword/${clientId}`, { password: password }).pipe();
    }

    public changeDevicePassword(clientId: string, passCode: string): Observable<any> {
        return this.post(`changeDevicePassword/${clientId}`, { passCode: passCode }).pipe();
    }
}



// WEBPACK FOOTER //
// ./src/app/core/http/internal/dealer.http.service.ts